/**
 * Shared currency formatting so money reads consistently across the app
 * (e.g. $1,350.00 instead of a raw 1350.0).
 */
export const formatCurrency = (value, currency = 'USD') => {
  if (value == null || value === '') return '—';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '—';
  const code = currency || 'USD';
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(num);
  } catch {
    return `${code} ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
};
